import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PullRequestOutlinedSvg from "@ant-design/icons-svg/es/asn/PullRequestOutlined";
import AntdIcon from "../components/AntdIcon";
var PullRequestOutlined = function PullRequestOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PullRequestOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PullRequestOutlined.displayName = 'PullRequestOutlined';
}
export default /*#__PURE__*/React.forwardRef(PullRequestOutlined);